<template>
  <div>
    <div>
      <aha-modal @hide="hide()" :title="title_DeleteConfirmation">
        <div>
          <div
            v-html="$i18nPresenter.
              t(
                `This presentation will be visible to everyone who has access to {name} folder.`,
                { name: folderName }
              )
            "
          >
          </div>
        </div>
        <template #action>
          <aha-link @click="hide()">
            <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
          </aha-link>
          <aha-button
            :disabled="isMovingPresn"
            @click="$emit('handleMovePresn')"
            icon-name="move"
            :submitting="isMovingPresn"
            has-margin-left
          >
            <aha-spinner variant="white" v-if="isMovingPresn" class="mr-1" />
            {{ $i18nPresenter.t("Move") }}
          </aha-button>
        </template>
      </aha-modal>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    folders: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    destinatedFolderId: {
      type: Number,
      default: () => {},
    },
    selectedPresentations: {
      type: Array,
      default: () => [],
    },
    isMovingPresn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title_DeleteConfirmation: this.$i18nPresenter.t('Access permission'),
      folderName: '',
    }
  },
  computed: {
    ...mapState({
      presentations: (state) => state.presentations,
    }),
  },
  async created() {
    if (this.destinatedFolderId) {
      this.folderName = this.folders
        .find((folder) => folder.folderId === this.destinatedFolderId).folderName
    }
  },
  methods: {
    ...mapActions(['setPresentationsAction', 'setErrorOnInternalServerAction']),
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
